export enum EventSources {
  CMS = 'CMS',
  WATCHTOWER = 'WATCHTOWER',
}
